export default {
  apply: {
    button: 'Restore this version',
    confirmation: 'Restore now',
    subtitle:
      'You restore the version of the schedule {name}. The current version of the schedule will be saved automatically.',
    success: {
      action: "Alright, let's go!",
      text: 'An old version of the schedule has been successfully restored. You can revert to your previous version using the version history.',
      title: 'Schedule restored',
    },
    title: 'Restore version',
    versionName: 'Restored: {name}',
  },
  automatic: {
    count: 'One automatic version | {n} automatic versions',
    info: 'Just that you know: ',
    placeholder: 'Automatic version from {date}',
    saving: 'A new automatic save point is generated',
  },
  information: {
    creator: 'Creator: {creator}',
    current: 'Current version',
    editor: 'Editor: {editor}',
    projectCreated: 'Project created',
    title: 'Learn more about versioning',
  },
  manual: {
    button: 'Save current version',
    placeholder: 'Name of version',
    subtitle:
      'The current version of the schedule is saved and can be found and restored later using the label.',
    title: 'Save version manually',
  },
  title: 'Restore schedule',
  manuallySaved: 'Manually saved',
  automaticallySaved: 'Automatically saved',
  versioningPreviewTitle: 'Restore schedule',
  versioningPreviewSidebarTitle: 'Version history',
  versionPreviewLoadingErrorTitle: 'Failed to load version',
  versionPreviewLoadingErrorMessage:
    'Selected version could not be loaded. Please try again later or contact our support if the error persists.',
  noSelectableVersionsTitle: 'No version saved yet',
  noSelectableVersionsMessage1: 'As soon as a plan got saved, it is listed here.',
  noSelectableVersionsMessage2:
    'koppla will also save versions every 15 mins for you, as long as there are updates in your schedule.',
  selectVersionCTA: 'Select a version to load the preview',
};
